import {
    Component,
    Inject,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import {
    Protocol,
    IProtocolInfo,
} from 'src/app/interfaces/protocol.interfaces';
import { ProtocolService } from 'src/app/services/protocol.service';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/lib/ariadna/alert';

import { APP_BASE_HREF, Location } from '@angular/common';
import {
    APP_DATE_FORMATS,
    formatInputDate,
    formatUiDate,
    parseDateTime,
} from 'src/app/shared/date/date.utils';

const modalOptions = {
    width: 'auto',
    height: 'auto',
    maxHeight: '80vh',
    // maxWidth: '70vw',
    closeOnNavigation: true,
};

@Component({
    selector: 'visit-protocol',
    templateUrl: 'visit-protocol.component.html',
    styleUrls: ['./visit-protocol.component.scss'],
    standalone: false,
})
export class VisitProtocolComponent implements OnInit {
    public isLoading = false;
    public isRequired = false;
    public closeDialogRef?: MatDialogRef<any, any>;
    public saveDialogRef?: MatDialogRef<any, any>;
    public protocol: Protocol = new Protocol([]);
    public formResultId: number;
    public visitID: number;
    public protocolInfo?: IProtocolInfo;
    public protocolStatus = {
        fullText: '',
        time: '',
    };
    public timeoutClose: NodeJS.Timeout | null = null;
    @ViewChild('closeModal') public closeModalTemplate?: TemplateRef<any>;
    @ViewChild('saveModal') public saveModalTemplate?: TemplateRef<any>;

    public constructor(
        public protocolService: ProtocolService,
        public dialog: MatDialog,
        public router: Router,
        public route: ActivatedRoute,
        public location: Location,
        public authService: AuthService,
        public alert: AlertService,
        @Inject(APP_BASE_HREF) private baseHref: string,
    ) {
        this.formResultId = this.route.snapshot.params.formID;
        this.visitID = this.route.snapshot.params.visitID;
        console.log(this.route);
    }

    public ngOnInit(): void {
        // console.log(this.authService.patientId, this.formResultId);
        if (this.authService && this.formResultId) {
            this.onLoad(this.visitID, this.formResultId);
        } else {
            this.router.navigate(['/home']);
            this.alert.error(
                'Ошибка открытия анкеты. Попробуйте открыть снова',
            );
            console.error(this.formResultId, this.authService);
        }
    }

    public async onLoad(visitID: number, formResultId: number) {
        try {
            this.isLoading = true;
            this.protocolInfo = (
                await this.protocolService.checkProtocol(formResultId, visitID)
            )[0];
            // console.log(this.protocolInfo);
            this.protocolStatus = this.getProtocolStatus(this.protocolInfo);

            if (!this.protocolInfo.isTruePat)
                throw new Error('Протокол не принадлежит пациенту.');
            this.protocol = await this.protocolService.getProtocol(
                formResultId,
                visitID,
            );
            // console.log(this.protocol);
        } catch (e) {
            console.log(e);
            this.router.navigate(['/home']);
            this.alert.error('Ошибка доступа к анкете.');
        } finally {
            this.isLoading = false;
        }
    }

    public getProtocolStatus(protocolInfo: IProtocolInfo) {
        const protocolStatus = {
            fullText: '',
            time: '',
        };

        const todayDate = formatInputDate(new Date());
        const isVisitToday = todayDate === protocolInfo.visitDat;
        const visitDate = parseDateTime(
            protocolInfo.visitDat,
            APP_DATE_FORMATS.INPUT_DATE,
        );
        const formattedVisitDate = visitDate
            ? formatUiDate(visitDate)
            : protocolInfo.visitDat;

        if (isVisitToday) {
            protocolStatus.fullText = 'Доступно до ' + protocolInfo.visitTime;
            protocolStatus.time = protocolInfo.visitTime;
        } else {
            protocolStatus.fullText = 'Доступно до ' + formattedVisitDate;
            protocolStatus.time = formattedVisitDate;
        }

        if (protocolInfo?.isExists) {
            protocolStatus.fullText = 'Сохранено';
        }

        return protocolStatus;
    }

    public onSubmit(e: Event) {
        this.save();
        e.preventDefault();
    }

    public async save() {
        try {
            this.isLoading = true;
            await this.protocolService.saveProtocol(
                this.protocol,
                this.visitID,
            );
            // console.log('save?');
            if (this.saveModalTemplate) {
                this.saveDialogRef = this.dialog.open(
                    this.saveModalTemplate,
                    modalOptions,
                );
            }
        } catch (e) {
            this.alert.error(
                'Произошла ошибка при сохранении анкеты. Попробуйте ещё раз.',
                2000,
            );
            console.error(e);
        } finally {
            this.isLoading = false;
            this.timeoutClose = setTimeout(() => {
                this.closeDialogRef?.close();
                this.saveDialogRef?.close();
                this.router.navigate(['/home/history']);
            }, 5000);
        }
    }

    public onClose() {
        for (const item of this.protocol.controls) {
            if (
                item.isRequired &&
                !item.item.formItemValText &&
                item.item.formResultVals?.length === 0
            ) {
                this.isRequired = true;
            }
        }

        if (this.isRequired) {
            if (this.closeModalTemplate) {
                if (this.timeoutClose) clearTimeout(this.timeoutClose);
                this.closeDialogRef = this.dialog.open(
                    this.closeModalTemplate,
                    modalOptions,
                );
            }
        } else this.goBack();
    }

    public goMyrec() {
        if (this.timeoutClose) clearTimeout(this.timeoutClose);
        this.saveDialogRef?.close();
        this.router.navigate([`/home/history`]);
    }

    public goBack() {
        this.closeDialogRef?.close();

        this.location.back();
    }

    public onCloseModal() {
        if (this.closeDialogRef) this.closeDialogRef.close();
        if (this.saveDialogRef) this.saveDialogRef.close();
    }
}
